import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from '../../globalStyles';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink
} from './Navbar.elements';
import logosite from '../../images/logosite.png';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <IconContext.Provider value={{ color: '#eb594c' }}>
        <Nav>
          <NavbarContainer>
            <NavLogo src={logosite}  />
              {/* <NavIcon /> */}
              {/* <img src="../../images/logosite.png" alt="logo" width="500" height="600"></img> */}
              {/* Novo Logo */}
              
            {/* </NavLogo> */}
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks to='/' onClick={closeMobileMenu}>
                  Home
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='/aboutus' onClick={closeMobileMenu}>
                  About Us
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='/productsandservices' onClick={closeMobileMenu}>
                  Services & Products
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='/projects' onClick={closeMobileMenu}>
                 Our Projects
                </NavLinks>
              </NavItem>
              {/* <NavItem>
                <NavLinks to='/contactus' onClick={closeMobileMenu}>
                 Contact Us
                </NavLinks>
              </NavItem> */}
              <NavItemBtn>
                {button ? (
                  <NavBtnLink to='/contactus'>
                    <Button primary>Contact Us</Button>
                  </NavBtnLink>
                ) : (
                  <NavBtnLink to='/contactus'>
                    <Button onClick={closeMobileMenu} fontBig primary>
                      Contact Us
                    </Button>
                  </NavBtnLink>
                )}
              </NavItemBtn>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
